module.exports = __webpack_public_path__ + "img/1-11.76049f78.svg";